import React, { useMemo } from 'react';
import {
  StyleProvider,
  defaultBrandingData,
  PrivacyPolicy,
} from '@relaynetwork/design-system';
import { FeedHeader } from '@app/client-config/product-group/components/feed-header/FeedHeader';

export type PrivacyPolicyPreviewProps = {
  showMenu: boolean;
  color: string;
};

export default function PrivacyPolicyPreview({
  showMenu = false,
  color,
}: PrivacyPolicyPreviewProps) {
  const brandingData = useMemo(
    () => ({
      ...defaultBrandingData,
      color: color,
    }),
    [color],
  );
  return (
    <StyleProvider brandingData={brandingData}>
      <FeedHeader
        showProductGroup={false}
        productGroupName={''}
        logoUrl={''}
        color={color}
        showBanner={false}
        showLogo={false}
        showTitleBar={false}
        isPreview={true}
        showMenu={showMenu} // Only this prop matters for Privacy Policy preview, the rest set to false/empty
      />

      <PrivacyPolicy isMobile={true} />
    </StyleProvider>
  );
}
